import styled, { keyframes } from "styled-components";
import { paletas } from "../../styles/theme";

const iconeAnima = keyframes`
  from {
    transform: rotate(45deg)
  }

  to {
    transform: rotate(0deg)
  }
`;

const botaoAnima = keyframes`
  0% {
    transform: scale(1)
  }

  50%{
    transform: scale(1.1)
  }

  100% {
    transform: scale(1)
  }
`;

const animaIconeWin = keyframes`
  from {
    opacity: 0.5;
    transform: translateY(100%) scale(0.5);
  }
  to {
    opacity: 1;
    transform: translateY(0%) scale(1);
  }
`;

export const Wrapper = styled.div`
  position: relative;

  div {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .wrapperIcon {
    transition: all 0.25s;
    animation: 0.25s ${animaIconeWin} linear;

    svg {
      margin-left: 5px;
    }
  }

  p {
    font-family: "Bebas Neue", cursive;
    font-family: "Open Sans", sans-serif;
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    margin: 5px;
    color: ${paletas.White};
  }
`;

export const BotaoFechar = styled.button`
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0;
  right: 0;
  margin-top: -30px;
  margin-right: -30px;
  border-radius: 50%;
  border: none;
  background: ${paletas.RedTheme};
  cursor: pointer;
  transition: all 0.25s;

  &:hover {
    background: ${paletas.Grafite75};
    animation: 0.5s ${botaoAnima} ease;
    svg {
      animation: 0.5s ${iconeAnima} ease;
    }
  }
`;
